<template>
  <div class="log-record">
    <div class="header">
      <div class="select">
        <mk-date-picker
          v-model="date"
          class="select-item"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        />
        <mk-select
          v-model="title"
          class="select-item"
          filterable
          clearable
          remote
          :remote-method="querySearchAsync"
          placeholder="搜索姓名"
          width="150"
          :loading="isFetchData"
        >
          <mk-option
            v-for="item in nameOptions"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </mk-option>
        </mk-select>
        <div class="btn-group">
          <mk-button-biz
            class="search-btn"
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz
            width="64px"
            class="reset-btn"
            @click="reset"
          >
            重置
          </mk-button-biz>
        </div>
      </div>
      <mk-button-biz
        class="export-btn"
        type="primary"
        :loading="loading"
        @click="exportXls"
      >
        导出
      </mk-button-biz>
    </div>
    <div class="sale-info">
      <p>{{ saleInfo.day }}</p>
      <p>提交日志人数：{{ saleInfo.submitTotal }}/<span>{{ saleInfo.verifyTotal }}</span></p>
    </div>
    <div class="content">
      <mk-table
        :data="list"
        height="100%"
      >
        <mk-table-column
          label="头像"
          width="50"
        >
          <template v-slot="scope">
            <img
              v-if="scope.row.sale[0] && scope.row.sale[0].avatarUrl"
              :src="scope.row.sale[0].avatarUrl"
              class="avatarUrl"
            >
            <img
              v-else
              class="avatarUrl"
              src="@/assets/images/user.png"
            >
          </template>
        </mk-table-column>
        <mk-table-column
          label="姓名"
          width="180"
        >
          <template v-slot="scope">
            <span v-if="scope.row.sale[0] && scope.row.sale[0].name">{{ scope.row.sale[0].name }}</span>
          </template>
        </mk-table-column>
        <mk-table-column label="日志内容">
          <template v-slot="scope">
            <!-- <span>{{ scope.row.workContent }}</span> -->
            <div>今日工作：{{ scope.row.workContent }}</div>
            <div>其他事项：{{ scope.row.otherItem ? scope.row.otherItem : '无' }}</div>
          </template>
        </mk-table-column>
        <mk-table-column
          label="日期"
          prop="day"
          width="200"
        />
        <mk-table-column
          label="操作"
          width="80"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              @click="handleDetail(scope.row)"
            >
              详情
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="handle-page">
      <!-- <div class="total-info">
        共{{ total }}条
      </div> -->
      <div class="page-info">
        <mk-pagination
          class="pagination"
          :current-page.sync="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </mk-pagination>
        <!-- <span class="page-tip">10条/页</span>
        <div class="jump">
          跳至
          <input
            v-model="nowPage"
            type="number"
            @keyup.enter="updatePage"
          />
          页
        </div> -->
      </div>
    </div>
    <sale-detail
      v-if="show"
      :user-info="userInfo"
      :show="show"
      @cancel="cancel"
    ></sale-detail>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import saleDetail from '../../statistical-performance/components/sale-detail.vue'
import { BIZAPIS } from '../../../../api'
export default {
  components: {
    saleDetail
  },
  data () {
    return {
      title: '',
      date: '',
      page: 1,
      nowPage: 1,
      total: 0,
      saleInfo: {
        day: '',
        submitTotal: 0,
        verifyTotal: 0
      },
      allSaleNumber: 0,
      show: false,
      list: [],
      nameOptions: [],
      isFetchData: false,
      loading: false
    }
  },
  created () {
    this.getList()
    this.getStatist()
  },
  methods: {
    async exportXls () {
      this.loading = true
      const metas = {}
      if (this.date) {
        metas['day'] = this.date
      } else {
        delete metas['day']
      }
      if (this.title) {
        metas['saleID'] = this.title
      } else {
        delete metas['saleId']
      }
      const res = await BIZAPIS.ExportApi.exportYqfWorkDailyGet(metas)
      if (res.success) {
        this.util.download({
          href: res.data
        })
        this.loading = false
      } else {
        this.loading = false
        this.$message({
          type: 'error',
          message: res.msg,
          showClose: true
        })
      }
    },
    cancel () {
      this.show = false
    },
    handleDetail (data) {
      this.show = true
      this.userInfo = {
        userId: data.sale[0]._id,
        ...data.sale[0]
      }
    },
    async querySearchAsync (str) {
      if (str) {
        this.isFetchData = true
        const res = await BIZAPIS.SalesApi.yqfSalesManageMatchGet({
          name: str
        })
        if (res.success) {
          this.isFetchData = false
          this.nameOptions = res.data.data
        }
      } else {
        this.isFetchData = false
        this.nameOptions = []
      }
    },
    search () {
      this.page = 1
      this.nowPage = 1
      this.getList()
      this.getStatist()
    },
    reset () {
      this.date = ''
      this.title = ''
    },
    handleCurrentChange (e) {
      this.nowPage = e
      this.page = e
      this.getList()
    },
    updatePage (e) {
      if (Number(this.nowPage) < 1) {
        this.nowPage = 1
        this.page = 1
      } else {
        if (Math.ceil(this.total / 10) <= Number(this.nowPage)) {
          this.nowPage = Math.ceil(this.total / 10)
        }
        this.page = Number(this.nowPage)
      }
      this.getList()
    },
    async getList () {
      let metas = {
        page: this.page
      }
      if (this.date) {
        metas['day'] = this.date
      } else {
        delete metas['day']
      }
      if (this.title) {
        metas['saleID'] = this.title
      } else {
        delete metas['saleId']
      }
      const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsLogGet(
        metas
      )
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    async getStatist () {
      let metas = {}
      if (this.date) {
        metas['day'] = this.date
      } else {
        delete metas['day']
      }
      const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsLogOverviewGet(
        metas
      )
      if (res.success) {
        this.saleInfo = res.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.log-record {
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      display: flex;

      .select-item {
        margin-right: 20px;
      }

      /deep/ .search-btn {
        padding: 0 14px !important;
        border-radius: 4px;

        .el-icon-search {
          font-size: 14px;
        }

        span {
          font-size: 13px;
          margin-left: 4px;
        }
      }

      /deep/ .reset-btn {
        span {
          font-size: 13px;
        }
      }
    }

    .new-add-btn {
      margin-right: 10px;
    }

    /deep/ .new-add-btn {
      padding: 0 8px !important;
    }

    /deep/ .export-btn {
      padding: 0 11px !important;
    }
  }

  .sale-info {
    width: calc(100% - 40px);
    margin: 0 auto;
    font-size: 13px;
    padding: 24px 0 16px 0;
    display: flex;

    p {
      margin-right: 32px;

      span {
        color: #888;
      }
    }
  }

  .content {
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    overflow: auto;

    .avatarUrl {
      display: block;
      width: 26px;
      height: 26px;
      border-radius: 2px;
    }
  }

  .handle-page {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 0 28px 0;

    .total-info {
      font-size: 13px;
      color: #6d7278;
      margin-left: 10px;
    }

    .page-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      // /deep/ .pagination {
      //   font-size: 13px;
      //   display: flex;
      //   align-items: center;
      //   margin-top: 0;

      //   .btn-prev {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-right: 6px solid #595959;

      //     .el-icon-arrow-left {
      //       display: none;
      //     }
      //   }

      //   .btn-prev:disabled {
      //     border-right: 6px solid #bfbfbf;
      //   }

      //   .btn-next {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-left: 6px solid #595959;

      //     .el-icon-arrow-right {
      //       display: none;
      //     }
      //   }

      //   .btn-next:disabled {
      //     border-left: 6px solid #bfbfbf;
      //   }

      //   .el-pager {
      //     margin: 0 8px;

      //     li {
      //       min-width: 30px;
      //       height: 24px;
      //       line-height: 24px;
      //     }
      //   }
      // }

      .page-tip {
        font-size: 14px;
        color: #595959;
        margin-left: -16px;
      }

      .jump {
        font-size: 13px;
        color: #595959;
        margin-left: 88px;

        input {
          width: 58px;
          height: 24px;
          padding: 0 12px;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
